import * as R from 'ramda';
export const caseIndifferentSearch = R.curry((searchString, targetString) => R.includes(R.toLower(searchString), R.toLower(targetString)));
export default caseIndifferentSearch;
